import React, { useState, useEffect } from 'react'
import API_Membros from '../components/API_Membros'

const API = () => {


    
    return (

        <div>
            
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-filter'></i>
                </div>
                <div class='header-title'>
                    <h1>API/BI</h1>
                    <small>Dados para relatórios</small>
                    
                </div>
            </div>

            


            
                <div className="panel panel-bd lobidrag">
                    
                    <div class="panel-body">

                        <ul className="nav nav-tabs">

                            <li className="active"><a href="#tab1" data-toggle="tab">Members</a></li>
                            <li ><a href="#tab3" data-toggle="tab" >Resíduos</a></li>
                            <li ><a href="#tab2" data-toggle="tab" >Clima</a></li>
                            
                            
                        </ul>
                            
                        <div class="tab-content">
                            <div class="tab-pane fade in active" id="tab1">
                                <div class="panel-body">

                                <API_Membros />
                                


                                </div>
                            </div>
                            <div className="tab-pane fade in" id="tab2">
                                <div class="panel-body">
                                    Dados Clima para API/BI
                                </div>

                            </div>

                            <div className="tab-pane fade in" id="tab3">

                                <div class="panel-body">
                                    Dados Resíduos para API/BI
                                </div>

                            </div>

                            
                    </div>


                    </div>
                </div>
           
        </div>
    )


}

export default API